// Actions
export const FETCH_WEATHER = 'FETCH_WEATHER',
             SET_WEATHER_TIME = 'SET_WEATHER_TIME',
             SET_LOCAL_WEATHER_SITE = 'SET_LOCAL_WEATHER_SITE',
             SET_WEATHER_SITE = 'SET_WEATHER_SITE',
             SET_WEATHER_LOCATION = 'SET_WEATHER_LOCATION',
             DOWNLOAD_DATA = 'DOWNLOAD_DATA';



// WEBPACK FOOTER //
// ./src/weather/types.js